import { useAnalyticsProps } from './useAnalyticsProps'
import useAnalytics from './useAnalytics'

/**
 * Simple hook-based analytics functions for React components
 * Provides a simplified API for common analytics events
 */
export const useAnalyticsAPI = (screen, isModal = false) => {
  const analytics = useAnalytics(screen, isModal)
  const getProps = useAnalyticsProps()

  return {
    trackScreenDisplay: (props = {}) => {
      analytics?.fireScreenDisplayed?.({
        ...getProps,
        ...props
      })
    },

    trackButtonClick: (buttonName, detail) => {
      analytics?.fireButtonClick?.(buttonName, {
        ...getProps,
        ...(detail ? { detail } : {})
      })
    },

    trackLinkClick: (linkName, detail) => {
      analytics?.fireHyperLinkClick?.(linkName, {
        ...getProps,
        ...(detail ? { detail } : {})
      })
    },

    trackControlAccordionExpanded: (controlName, props = {}) => {
      analytics?.fireControlAccordionExpanded?.(controlName, {
        ...getProps,
        ...props
      })
    }
  }
}

/**
 * Factory functions for creating common analytics configurations
 */
export const createScreenConfig = (
  screenName,
  screenPath,
  activity = 'HardwareSetup-v01'
) => ({
  screenName,
  screenPath,
  activity
})

export const createModalConfig = (
  screenName,
  screenPath,
  activity = 'HardwareSetup-v01'
) => createScreenConfig(screenName, screenPath, activity)
